import type {
  ListIncomingTransfersResponseDtoOutput,
  ListOutgoingTransfersResponseDtoOutput,
  TransactionTableRow,
} from '@peanuds/shared';
import {
  mapIncomingTransfers as mapIncomingBaseTransfers,
  mapOutgoingTransfers as mapOutgoingBaseTransfers,
} from './transactions.boundary';
import type { IncomingTransfer, OutgoingTransfer } from './transactions.types';

type IncomingTransferDto = NonNullable<ListIncomingTransfersResponseDtoOutput['data']>[number];
type OutgoingTransferDto = NonNullable<ListOutgoingTransfersResponseDtoOutput['data']>[number];

const toString = (value: unknown): string => {
  return typeof value === 'string' ? value : '';
};

export type AnalyticsTransactionRow = TransactionTableRow & {
  id: string;
  direction: 'in' | 'out';
  dateAndTime: string;
  transactionId: string;
  type: string;
};

export const mapIncomingTransfers = (
  incomingTransfers: IncomingTransferDto[],
): AnalyticsTransactionRow[] => {
  return mapIncomingBaseTransfers(incomingTransfers).map((transfer: IncomingTransfer, index) => {
    const originalTransfer = incomingTransfers[index];
    const transactionId = toString(originalTransfer?.id);
    const id = transactionId || `in-${index}`;

    return {
      ...transfer,
      id,
      amount: transfer.amount ?? undefined,
      direction: 'in',
      dateAndTime: transfer.transferDate ?? '',
      transactionId,
      type: transfer.type,
      currency: transfer.currency ?? 'EUR',
    };
  });
};

export const mapOutgoingTransfers = (
  outgoingTransfers: OutgoingTransferDto[],
): AnalyticsTransactionRow[] => {
  return mapOutgoingBaseTransfers(outgoingTransfers).map((transfer: OutgoingTransfer, index) => {
    const originalTransfer = outgoingTransfers[index];
    const transactionId = toString(originalTransfer?.id);
    const id = transactionId || `out-${index}`;

    return {
      ...transfer,
      id,
      amount: transfer.amount ?? undefined,
      direction: 'out',
      dateAndTime: transfer.transferDate ?? '',
      transactionId,
      type: transfer.type,
      currency: transfer.currency ?? 'EUR',
    };
  });
};
